import React, { useEffect } from 'react';

interface MobileSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  side?: 'left' | 'right';
}

export const MobileSheet: React.FC<MobileSheetProps> = ({ isOpen, onClose, children, side = 'right' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Calculate sheet position classes to avoid nested ternary
  const sidePositionClass = side === 'right' ? 'right-0' : 'left-0';
  let translateClass = '';
  if (isOpen) {
    translateClass = 'translate-x-0';
  } else if (side === 'right') {
    translateClass = 'translate-x-full';
  } else {
    translateClass = '-translate-x-full';
  }

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* Backdrop */}
      <div
        role="button"
        tabIndex={0}
        className="fixed inset-0 bg-black/50"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClose();
          }
        }}
        aria-label="Close menu"
      />

      {/* Sheet */}
      <div
        className={`fixed top-0 h-full w-64 bg-background border-l border-border shadow-lg transform transition-transform ${sidePositionClass} ${translateClass}`}>
        {children}
      </div>
    </div>
  );
};
